<template>
    <div>
        <edit-member-communication-modal
            v-model="show_communication_dialog"
            :constants="constants"
            :modelProp="communicationSelected"
            :memberId="this.member.id"
        />
        <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-4 tw-p-1">
            <div class="tw-flex tw-flex-col tw-w-full md:tw-w-1/2 tw-gap-4"><!-- left side -->
                <internal-table-section :has-button="false" class="tw-w-full">
                    <div class="tw-flex tw-justify-between">
                        <div :class="(member.web_access)?'tw-text-secondary':'tw-text-gray-300'">Web Access</div>
                        <div :class="(member.print_statement)?'tw-text-secondary':'tw-text-gray-300'">Print Statement</div>
                        <div :class="(member.casl)?'tw-text-secondary':'tw-text-gray-300'">CASL</div>
                        <div :class="(member.mentor)?'tw-text-secondary':'tw-text-gray-300'">Mentor </div>
                    </div>
                </internal-table-section>

                <internal-table-section :has-button="false" class="tw-w-full">
                    <div class="tw-flex tw-flex-col ">
                        <div class="tw-pb-2">
                            <v-text-field
                                :value="member.company"
                                :outlined="false"
                                readonly
                                label="Company"
                            ></v-text-field>
                        </div>

                        <div class="tw-flex tw-gap-3 tw-pb-2">
                            <v-text-field
                                :value="member.local"
                                :outlined="false"
                                readonly
                                label="Local"
                                class="tw-w-1/3"
                            ></v-text-field>
                            <v-text-field
                                :value="member.designation"
                                :outlined="false"
                                readonly
                                label="Designation"
                                class="tw-w-1/3"
                            ></v-text-field>
                            <v-text-field
                                :value="member.language"
                                :outlined="false"
                                readonly
                                label="Language"
                                class="tw-w-1/3"
                            ></v-text-field>
                        </div>

                        <div class="tw-pb-2">
                            <v-text-field
                                :value="member.status?.classification_name"
                                :outlined="false"
                                readonly
                                label="Classification"
                            ></v-text-field>
                        </div>

                        <div class="tw-pb-2">
                            <v-text-field
                                :value="member.status_updated_at"
                                :outlined="false"
                                readonly
                                label="Date (Status change)"
                            ></v-text-field>
                        </div>

                        <div class="tw-flex tw-justify-between">
                            <div :class="(member.age_25_and_65)?'tw-text-secondary':'tw-text-gray-300'">25/65</div>
                            <div :class="(member.ia_retiree)?'tw-text-secondary':'tw-text-gray-300'">IARetiree</div>
                        </div>
                    </div>
                </internal-table-section>

                <internal-table-section :has-button="false" class="tw-w-full">
                    <div class="tw-flex tw-flex-col">
                        <div class="tw-flex tw-gap-3 tw-pb-2">
                            <v-text-field
                                :value="member.agent_name"
                                :outlined="false"
                                readonly
                                label="DP Agent Name"
                                class="tw-w-1/2"
                            ></v-text-field>
                            <v-text-field
                                :value="member.other_prod_details"
                                :outlined="false"
                                readonly
                                label="Other Prod Details"
                                class="tw-w-1/2"
                            ></v-text-field>
                        </div>

                        <div class="tw-flex tw-gap-3 tw-pb-2">
                            <v-text-field
                                :value="member.agent_agency"
                                :outlined="false"
                                readonly
                                label="Agency"
                                class="tw-w-1/2"
                            ></v-text-field>
                            <v-text-field
                                :value="member.region"
                                :outlined="false"
                                readonly
                                label="Region"
                                class="tw-w-1/2"
                            ></v-text-field>
                        </div>

                        <div>
                            <v-text-field
                                :value="member.agent_phone_number"
                                :outlined="false"
                                readonly
                                label="Agent Phone"
                                class="tw-w-1/2"
                            ></v-text-field>
                        </div>
                    </div>
                </internal-table-section>
            </div>

            <div class="tw-flex tw-flex-col tw-w-full md:tw-w-1/2 tw-gap-4"><!-- right side -->
                <internal-table-section :has-button="false" section-title="Mailing Address" class="tw-w-full">
                    <div class="tw-flex tw-flex-col tw-px-4 tw-pt-3">
                        <div class="tw-flex tw-gap-3 tw-pb-2">
                            <v-text-field
                                :value="member.mailing_address[0]?.first_name"
                                :outlined="false"
                                readonly
                                label="First Name"
                                class="tw-w-1/2"
                            ></v-text-field>
                            <v-text-field
                                :value="member.mailing_address[0]?.last_name"
                                :outlined="false"
                                readonly
                                label="Last Name"
                                class="tw-w-1/2"
                            ></v-text-field>
                        </div>

                        <div class="tw-pb-2">
                            <v-text-field
                                :value="member.mailing_address[0]?.company"
                                :outlined="false"
                                readonly
                                label="Company"
                            ></v-text-field>
                        </div>

                        <div class="tw-flex tw-gap-3 tw-pb-2">
                            <v-text-field
                                :value="member.local"
                                :outlined="false"
                                readonly
                                label="Local"
                                class="tw-w-1/3"
                            ></v-text-field>
                            <v-text-field
                                :value="member.mailing_address[0]?.designation"
                                :outlined="false"
                                readonly
                                label="Designation"
                                class="tw-w-1/3"
                            ></v-text-field>
                            <v-text-field
                                :value="member.language"
                                :outlined="false"
                                readonly
                                label="Language"
                                class="tw-w-1/3"
                            ></v-text-field>
                        </div>

                        <div class="tw-pb-2">
                            <v-text-field
                                :value="member.mailing_address[0]?.address1"
                                :outlined="false"
                                readonly
                                label="Address"
                            ></v-text-field>
                        </div>

                        <div class="tw-flex tw-gap-3 tw-pb-2">
                            <v-text-field
                                :value="member.mailing_address[0]?.city"
                                :outlined="false"
                                readonly
                                label="City"
                                class="tw-w-1/3"
                            ></v-text-field>
                            <v-text-field
                                :value="member.mailing_address[0]?.province?.name"
                                :outlined="false"
                                readonly
                                label="Province"
                                class="tw-w-1/3"
                            ></v-text-field>
                            <v-text-field
                                :value="member.mailing_address[0]?.country?.name"
                                :outlined="false"
                                readonly
                                label="Country"
                                class="tw-w-1/3"
                            ></v-text-field>
                        </div>

                        <div>
                            <v-text-field
                                :value="member.mailing_address[0]?.postal_code"
                                :outlined="false"
                                readonly
                                label="Postal Code"
                                class="tw-w-1/3"
                            ></v-text-field>
                        </div>
                    </div>
                </internal-table-section>
                <internal-table-section button-text="Save" @button-clicked="saveComment" :is-loading="saveLoading" class="tw-w-full tw-h-full">
                    <div class="tw-flex tw-flex-col">
                        <v-textarea
                            v-model="member.note"
                            label="Comment"
                            auto-grow
                            :error-messages="errors?.note"
                            hide-details="auto"
                            filled
                            dense
                            rows="2"
                        ></v-textarea>
                    </div>
                </internal-table-section>
            </div>
        </div>

        <div class="tw-flex tw-flex-col mt-2 mb-2">
            <div class="tw-flex tw-flex-row tw-pb-3 tw-mb-2 tw-justify-between tw-border-b-2 tw-border-secondary tw-gap-2">
                <h4 class="tw-font-normal tw-mt-2">Communications</h4>
                <div class="tw-flex tw-flex-row tw-gap-4">
                    <v-btn :disabled="isFirstSlide" class="main-btn" @click="goPrev"><</v-btn>
                    <v-btn :disabled="isLastSlide" class="main-btn" @click="goNext">></v-btn>
                    <v-btn class="main-btn" @click="addCommunication">+</v-btn>
                </div>
            </div>
            <div class="splideContainer">
                <div v-if="member.communications.length < 1">No Communications created.</div>
                <Splide ref="splide1" :options="splide_options">
                    <SplideSlide v-for="communication in member.communications" :key="communication.id" class="tw-py-2 tw-px-3">
                        <internal-table-section class="skillBoxes" button-text="Edit" @button-clicked="editCommunication(communication)">
                            <div class="container">
                                <div class="row">
                                    <h4>{{ communication.communication }}</h4>
                                </div>
                                <div class="row">
                                    <h5>{{ communication.date_communication }}</h5>
                                </div>
                                <div class="row pt-3">
                                    <v-textarea
                                        label="Notes"
                                        outlined
                                        readonly
                                        auto-grow
                                        compact
                                        :value="communication.note">
                                    </v-textarea>
                                </div>
                                <div class="row">
                                    Created by: {{ communication.creator?.first_name }} {{ communication.creator?.last_name }}
                                </div>
                            </div>
                        </internal-table-section>
                    </SplideSlide>
                </Splide>
            </div>

        </div>



    </div>
</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import InternalHeader from "@/Generic/InternalHeader";
    import InternalTableSection from "@/Generic/InternalTableSection";
    import {Splide, SplideSlide} from "@splidejs/vue-splide";
    import EditMemberCommunicationModal from "@/Pages/InternalPages/Members/Modals/EditMemberCommunicationModal";

    export default {
        name: "MembersShowOverview",
        components: {
            EditMemberCommunicationModal,
            SmartTable,
            InternalHeader,
            InternalTableSection,
            Splide,
            SplideSlide,
        },
        props: {
            'input': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
        },
        data() {
            return {
                member: this.input,
                constant: this.constants,
                saveLoading: false,
                splide: null,
                isLastSlide: false,
                isFirstSlide: false,
                show_communication_dialog: false,
                communicationSelected: this.skill,
                errors: null,
            }
        },
        computed: {
            num_slides_per_page() {
                switch (this.$vuetify.breakpoint.name) {
                    case "xs": return 1
                    case "sm": return 1
                    case "md": return 2
                    case "lg": return 4
                    default: return 3
                }
            },
            width_of_slides() {
                switch (this.$vuetify.breakpoint.name) {
                    case "xs": return '85%'
                    case "sm": return '75%'
                    case "md": return '320px'
                    case "lg": return '370px'
                    default: return '340px'
                }
            },
            splide_options () {
                return {
                    type: 'slide',
                    autoplay: false,
                    pauseOnHover: false,
                    resetProgress: true,
                    perPage: this.num_slides_per_page,
                    navigation: false,
                    pagination: false,
                    arrows: false,
                    drag: false,
                    keyboard: false,
                    fixedWidth: this.width_of_slides,
                }
            },
        },
        mounted() {
            const splideInstance = this.$refs.splide1.splide
            if(splideInstance.length > this.splide_options.perPage){
                this.isFirstSlide = true
            }
        },
        methods: {
            editCommunication(communication) {
                this.communicationSelected = communication
                this.show_communication_dialog = true
            },
            addCommunication() {
                this.communicationSelected = null
                this.show_communication_dialog = true
            },
            saveComment() {
                let url = route('members.update', this.member.id)
                let data = this.member
                axios({
                    method: 'put',
                    url: url,
                    data: data,
                    onUploadProgress: (evt) => {
                        this.saveLoading = !this.saveLoading
                    },
                    onDownloadProgress: (evt) => {
                        this.saveLoading = !this.saveLoading
                    },
                })
                    .then(response =>
                    {
                        if (response.data.success) {
                            this.$root.is_dirty = false
                            this.$root.snackbar.success('Comment has been saved')
                            this.$root.is_dirty = false
                            this.saveLoading = false
                            this.$emit('successful-member-note-save')
                        } else if( response.data?.error ) {
                            throw (response.data?.error)
                        } else {
                            throw ('Unknow error.')
                        }
                    })
                    .catch((error) => {
                        if( error?.response ) {
                            this.$root.snackbar.error(error.response.data.message)
                            this.errors = error.response?.data?.errors
                        } else {
                            console.log(error)
                            this.$root.snackbar.error(error)
                        }
                        this.saveLoading = false
                    })
            },
            checkFirstSlide() {
                const splideInstance = this.$refs.splide1.splide
                const isFirstSlide = splideInstance.index === 0
                if (isFirstSlide) {
                    this.isFirstSlide = true
                } else {
                    this.isFirstSlide = false
                }
            },


            checkLastSlide() {
                const splideInstance = this.$refs.splide1.splide
                const lastIndex = splideInstance.length - 1
                const isLastSlide = splideInstance.index >= lastIndex - splideInstance.options.perPage + 1
                if (isLastSlide) {
                    this.isLastSlide = true
                } else {
                    this.isLastSlide = false
                }
            },
            goPrev() {
                this.$refs.splide1.go('-1')
                this.checkFirstSlide()
                this.checkLastSlide()
            },
            goNext() {
                this.$refs.splide1.go('+1')
                this.checkFirstSlide()
                this.checkLastSlide()
            },
        },
        created() {
            import('@splidejs/splide/dist/css/splide.min.css')
        },
        watch: {
            input(newInput, oldInput) {
                this.member = newInput
            },
        }
    }
</script>

<style>

</style>
